import React from "react";

export const Headline = ({show, headline, subhead}) => (
    <div className={`${!show && 'Hide'} Headline`}>
        <h1>{headline}</h1>
        <div dangerouslySetInnerHTML={{__html: subhead}}></div>
    </div>
);